/**
 * GHA-404: svc-connection-google answers a GHA voucher mint with `applyPublicRate` when it has
 * flagged the shopper (hotel, uncertain or a blocked identity). While the marker is fresh
 * the session prices at the public rate: no member-only (CUG) rate, no price match, no voucher.
 *
 * Kept as the time it was set, in a cookie so server rendering agrees with the client, and checked
 * for expiry wherever it is read.
 */
export const METASEARCH_PUBLIC_RATE_COOKIE = 'msPublicRate'
/** Matches the `utm_bp` cookie that makes the session GHA traffic at all. */
export const METASEARCH_PUBLIC_RATE_TTL_HOURS = 3
const METASEARCH_PUBLIC_RATE_TTL_MS = METASEARCH_PUBLIC_RATE_TTL_HOURS * 60 * 60 * 1000

/** True while a marker written at `markedAt` still applies. */
export function isMetasearchPublicRateActive(markedAt: number | undefined, now = Date.now()): boolean {
  return markedAt !== undefined && Number.isFinite(markedAt) && now - markedAt < METASEARCH_PUBLIC_RATE_TTL_MS
}

/** The time the marker was set, or undefined when the cookie is absent, malformed or expired. */
export function parseMetasearchPublicRateCookie(cookieValue: string | undefined, now = Date.now()): number | undefined {
  if (!cookieValue) return undefined
  const markedAt = Number(cookieValue)
  return isMetasearchPublicRateActive(markedAt, now) ? markedAt : undefined
}

export function serializeMetasearchPublicRateCookie(markedAt: number): string {
  return String(markedAt)
}
